/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmailScheduleRunExcludingPayloadWithRelations } from './emailScheduleRunExcludingPayloadWithRelations';


/**
 * (tsType: Omit<EmailScheduleWithRelations, \'payload\'>, schemaOptions: { includeRelations: true, exclude: [ \'payload\' ] })
 */
export interface EmailScheduleExcludingPayloadWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    subject: string;
    recipientCount?: number;
    runs?: Array<EmailScheduleRunExcludingPayloadWithRelations>;
}

